import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../LoadingIndicator';
import isSSR from '../utils/isSSR';
import { MobileContext } from '../Context';
import s from './IframePopup.scss';
var POPUP_TITLE_HEIGHT = 68;
var IframePopup = /** @class */ (function (_super) {
    __extends(IframePopup, _super);
    function IframePopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            width: _this.props.initialWidth || 400,
            height: _this.props.initialHeight || 300,
            loaded: false,
        };
        _this.onMessage = function (event) {
            var onMessage = _this.props.onMessage;
            onMessage && onMessage(event);
        };
        _this.onLoad = function () {
            _this.setState({ loaded: true });
        };
        _this.requestResize = function (size) {
            var title = _this.props.title;
            var width = size.width, height = size.height;
            _this.setState(__assign(__assign({}, _this.state), { width: width, height: (title ? (height + POPUP_TITLE_HEIGHT) : height) }));
        };
        return _this;
    }
    IframePopup.prototype.componentDidMount = function () {
        window.addEventListener('message', this.onMessage);
    };
    IframePopup.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.onMessage);
    };
    IframePopup.prototype.getDimensions = function () {
        var isMobile = this.context;
        var _a = this.state, width = _a.width, height = _a.height;
        return isMobile && !isSSR()
            ? {
                width: window.innerWidth,
                height: window.innerHeight,
            }
            : {
                width: width,
                height: height,
            };
    };
    IframePopup.prototype.render = function () {
        var _a = this.props, src = _a.src, title = _a.title, className = _a.className;
        var loaded = this.state.loaded;
        var _b = this.getDimensions(), width = _b.width, height = _b.height;
        return (React.createElement("div", { className: s['root'], style: { width: width, height: height } },
            title && React.createElement("div", { className: s['title'] }, title),
            React.createElement("iframe", { title: title, className: classnames(s['iframe'], className), src: src, width: width, height: title ? (height - POPUP_TITLE_HEIGHT) : height, onLoad: this.onLoad }),
            !loaded && React.createElement(LoadingIndicator, { coverMode: true, withOverlay: true, view: "daSymbol" })));
    };
    IframePopup.contextType = MobileContext;
    return IframePopup;
}(React.Component));
export { IframePopup };
export default IframePopup;
//# sourceMappingURL=IframePopup.js.map